import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { teamService } from '@/services/team-service';
import type { Team } from '@/types/core/team';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { teamQueryKeys } from './query-keys';

/**
 * Find a specific team by ID.
 * Returns a react-query query.
 */
export function useFindTeam(
  tenantId?: UUID,
  teamId?: UUID
): UseQueryResult<Team | null, Error> {
  return useQuery<Team | null, Error>({
    queryKey: teamQueryKeys.detail(tenantId, teamId),
    queryFn: async () => {
      if (isEmptyUUID(tenantId) || isEmptyUUID(teamId)) return null;
      return teamService.findTeam(tenantId!, teamId!);
    },
    enabled: !isEmptyUUID(tenantId) && !isEmptyUUID(teamId),
  });
}
